<template>
  <div class="welcome">
    <div class="title">{{ $t('app.homePage.welcome', { userName }) }}</div>
    <div class="info">
      {{ $t('app.homePage.unreadCount', { count: info.unreadNotificationCount }) }}
    </div>
    <div class="info">
      <span v-if="info.lastLoginAt"
        >{{ $t('app.homePage.lastLogin') }} {{ info.lastLoginAt | formatDateTime }}</span
      >
      <span v-else> {{ $t('app.homePage.firstLogin') }} </span>
    </div>
    <div v-if="displayStatuses.length" class="info">
      {{ $t('app.homePage.displays') }}
      <span v-if="!displayStatuses.includes('System')">
        <span v-for="(s, idx) of displayStatuses" :key="idx" class="blurb" :class="classify(s)">{{
          s
        }}</span>
      </span>
      <span v-else>
        {{ $t('app.homePage.sysAdminBlurb') }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userName: {
      type: String,
      required: true
    },
    info: {
      type: Object,
      required: true
    },
    displayStatuses: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    classify(str) {
      return str
        .toLowerCase()
        .split(' ')
        .join('-');
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';
.welcome {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #ccc;
  background-color: $white;
  padding: 60px;
  font-size: 12px;
  .title {
    border-bottom: 1px solid $row-border;
  }
  .info {
    margin-top: 8px;
    color: $mid-grey-2;
    font-size: 12px;
    span.blurb {
      &::before {
        content: '⬤';
      }
      margin-right: 8px;

      &.submitted {
        color: orange;
      }
      &.approved {
        color: $blue;
      }
      &.rejected {
        color: $red;
      }
      &.active-online {
        color: $green;
      }
      &.active-offline {
        color: $purple;
      }
    }
  }
}

@media only screen and (min-width: 768px) {
  .welcome {
    font-size: 20px;
    .info {
      font-size: 20px;
    }
  }
}
</style>
